let numberIncrease = {
    inserted(el, binding) {
        let count = 0;
        let element = el.querySelector('.ant-statistic-content-value-int') || el.querySelector('.ant-statistic-content-value');
        let value = element.innerText;
        let formatValue = parseInt(value.replace(',', ''));
        let speed = 0;

        if(formatValue >= 1000) {
            speed = 100;
        }else if(formatValue >= 100) {
            speed = 10;
        }else {
            speed = 1;
        }

        let timer = setInterval(() => {
            count += speed;
            element.innerText = count;
            if(count > formatValue) {
                count = value;
                element.innerText = value;
                clearInterval(timer);
                timer = null;
            }
        }, 10);
    }
}

export default numberIncrease